import { SafeUrl } from "@angular/platform-browser";
export class Upload {
	content: string | ArrayBuffer;
	filedate: string;
	id: number;
	mimetype: string;
	name: string;
	url: SafeUrl;
}
